<template>
  <div class="instagram-feed">
    <div class="subheading">{{ subheading }}</div>
    <h3 class="heading">{{ heading }}</h3>
    <div class="photos">
      <InstagramTile v-for="tile in tiles" :key="tile.key" :tile="tile" />
    </div>
  </div>
</template>

<script>
import InstagramTile from "@/components/InstagramTile";
export default {
  name: "InstagramFeed",
  components: {
    InstagramTile,
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
    subheading: {
      type: String,
      required: true,
    },
    tiles: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.instagram-feed {
  padding: 60px 0 0;

  @include respond-above(md) {
    padding: 80px 0 0;
  }

  .photos {
    display: flex;
    line-height: 0;
    overflow-x: scroll;
    white-space: nowrap;

    & > * {
      flex: 1 0 250px;
      margin-right: 2px;

      &:first-child {
        @include respond-above(md) {
          margin-left: 2px;
        }
      }

      &:last-child {
        margin-right: 0;
      }

      @include respond-above(md) {
        flex: 1 0 330px;
      }
    }
  }
}

.heading {
  font-size: 24px;
  font-weight: 700;
  margin: 0 auto 10px;
  max-width: 90%;
  text-align: center;
  text-transform: uppercase;

  @include respond-above(md) {
    font-size: 50px;
    width: auto;
  }
}

.subheading {
  font-size: 9px;
  font-weight: 600;
  line-height: 12px;
  letter-spacing: 0.49px;
  margin: 0 0 5px;
  text-align: center;
  text-transform: uppercase;

  @include respond-above(md) {
    font-size: 10px;
    line-height: 14px;
  }
}
</style>
